import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './TrafficUsageProgressBar.module.css';
import ProgressBar from '../../../ProgressBar';
import Skeleton from '../../../Skeleton';
import Message from '../../../Message';
import { useTranslation } from '../../../Translator';

const SUBSCRIPTION_VIEW_PATH = '/administration/account/subscription';
const bindClasses = classNameBind.bind(styles);

const TrafficUsageProgressBar = ({
  loading,
  progress,
  error,
  clickable,
  color,
}) => {
  const { t } = useTranslation('components');

  if (loading) {
    return (
      <div className={bindClasses('no-data-wrapper')}>
        <Skeleton width="100%" height={8} />
        <Skeleton width="70%" height={8} />
      </div>
    );
  }

  if (error) {
    return (
      <div className={bindClasses('no-data-wrapper')}>
        <Message message={t('trafficUnableToLoad')} messageType="error" vertical={false} />
      </div>
    );
  }

  return (
    <a
      tabIndex={0}
      href={SUBSCRIPTION_VIEW_PATH}
      className={bindClasses('wrapper', { clickable })}
    >
      <ProgressBar mainColor={color} progress={progress} hideProgressNumber />
      <span>
        {t('trafficPercentageLimit', { percentage: progress })}
      </span>
    </a>
  );
};

export { TrafficUsageProgressBar };
